(() => {
  const roots = document.querySelectorAll('[data-byw-root]');
  roots.forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const card = root.querySelector('#shg-enter-form');
    const status = root.querySelector('[data-byw-status]');
    const host = root.querySelector('[data-byw-form]');
    const embed = root.querySelector('[data-byw-embed]');
    const mobile = root.querySelector('[data-byw-mobile]');
    const cta = root.querySelector('[data-byw-cta]');
    const bonus = root.querySelector('[data-byw-bonus]');
    const start = Date.parse(root.dataset.open);
    const end = Date.parse(root.dataset.close);
    const preview = root.dataset.editor === 'true' && root.dataset.preview === 'true';
    let mounted = false, sent = false, phase = '', heroVisible = true, formVisible = false;
    const getPhase = () => {
      if (root.dataset.mode === 'closed') return 'closed';
      if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return 'unavailable';
      if (Date.now() >= end) return 'closed';
      if (preview) return 'open';
      return Date.now() < start ? 'upcoming' : 'open';
    };
    const track = formId => {
      if (!root.isConnected || getPhase() !== 'open' || sent || !root.dataset.formId || formId !== root.dataset.formId) return;
      if (window.Shopify?.analytics?.publish) {
        sent = true;
        const eventName = root.dataset.editor === 'true' ? 'byw_entry_test' : 'byw_entry';
        window.Shopify.analytics.publish(eventName, { campaign: 'byw2026', form_id: formId });
      }
    };
    window.addEventListener('message', event => {
      if (!root.isConnected) return;
      let origin;
      try { origin = new URL(event.origin); } catch { return; }
      const trustedEmbed = origin.protocol === 'https:' && /(^|\.)hsforms\.(com|net)$/.test(origin.hostname);
      const trustedPage = event.origin === window.location.origin && event.source === window;
      if (!trustedEmbed && !trustedPage) return;
      const data = event.data;
      if (data?.type === 'hsFormCallback' && data.eventName === 'onFormSubmitted') track(data.id);
    });
    window.addEventListener('hs-form-event:on-submission:success', event => track(event.detail?.formId));
    const updateMobile = () => { if (mobile) mobile.hidden = phase !== 'open' || heroVisible || formVisible; };
    const mount = async () => {
      if (mounted || !embed.content.textContent.trim() && !embed.content.querySelector('script')) return false;
      mounted = true;
      const fragment = embed.content.cloneNode(true);
      const scripts = [...fragment.querySelectorAll('script')];
      const markers = scripts.map(script => {
        const marker = document.createElement('span');
        marker.hidden = true;
        script.replaceWith(marker);
        return marker;
      });
      host.appendChild(fragment);
      for (let i = 0; i < scripts.length; i++) {
        if (getPhase() !== 'open' || !root.isConnected) break;
        const source = scripts[i], script = document.createElement('script');
        [...source.attributes].forEach(attr => script.setAttribute(attr.name, attr.value));
        script.textContent = source.textContent;
        if (source.src) {
          await new Promise((resolve, reject) => {
            script.onload = resolve;
            script.onerror = reject;
            markers[i].replaceWith(script);
          });
        } else markers[i].replaceWith(script);
      }
      return true;
    };
    const update = () => {
      if (!root.isConnected) return;
      const next = getPhase();
      if (next !== phase) {
        phase = next;
        host.hidden = phase !== 'open';
        status.hidden = phase === 'open';
        if (bonus) bonus.hidden = phase === 'closed';
        if (phase === 'closed') {
          host.replaceChildren();
          status.textContent = 'Entries are closed. The Build Your World Sweepstakes ended December 15, 2026 at 11:59 pm MT. Thank you to everyone who entered. We’re drawing the winner on December 16 and will contact them directly.';
          cta.textContent = 'See the official rules';
          cta.href = '/pages/build-your-world-2026-official-rules';
        } else if (phase === 'upcoming') {
          status.textContent = 'Entries open October 15, 2026. Please come back then to enter.';
          cta.textContent = 'See how to enter';
        } else if (phase === 'unavailable') {
          status.textContent = 'Online entry is currently unavailable. Please contact sweepstakes@sunstonewelders.com for help.';
        } else {
          cta.textContent = 'Enter to win';
          mount().then(ok => {
            if (!ok) { status.hidden = false; status.textContent = 'Online entry is not available yet. Please check back soon.'; }
          }).catch(() => {
            status.hidden = false;
            status.textContent = 'The entry form could not load. Please refresh the page or contact sweepstakes@sunstonewelders.com.';
          });
        }
        updateMobile();
      }
      const boundary = phase === 'upcoming' ? start : end;
      if (phase !== 'closed' && phase !== 'unavailable') setTimeout(update, Math.max(100, Math.min(30000, boundary - Date.now())));
    };
    if ('IntersectionObserver' in window && mobile) {
      new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === card) formVisible = entry.isIntersecting;
          else heroVisible = entry.isIntersecting;
        });
        updateMobile();
      }).observe(card);
      new IntersectionObserver(entries => { heroVisible = entries[0].isIntersecting; updateMobile(); }).observe(root.querySelector('.shg-hero'));
    }
    document.addEventListener('visibilitychange', () => { if (!document.hidden && root.isConnected && getPhase() !== phase) update(); });
    update();
  });
})();
